import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, toRefs } from 'vue'
import useGlobal from '../../composables/useGlobal'
import executeWithRefresh from '@/composables/useRefresher'
import { userOrdersListResource, userKeysListResource } from '@/services/order.service'
import { STATE } from '@/utils/base64'
import { differenceInDays } from 'date-fns'
import { storage } from '@/utils/session'
import {
  HQ_VPN_IS_AUTH_STORAGE_NAME,
} from '@/const'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserCabinet',
  props: ['paymentPage', 'mainPage'],
  setup(__props, { expose }) {
  expose();

const props = __props

const router = useRouter()
const route = useRoute()
const { $t } = useGlobal()

const kyesList = ref('')
const ordersList = ref([])
const keysTypes = ref({
  trial: $t('Временный доступ'),
  subscription: $t('Платный доступ'),
})

const { loginPage } = toRefs(props)

const pagination = ref({})

function getDaysForDate(dateFor) {
  return differenceInDays(new Date(dateFor), new Date())
}
function updateKey( key ) {
  const subId = ref('')
  ordersList.value.forEach(order => {
    if(key == order.meta.key) {
      
      subId.value = order.meta.subscription
    }
    
  });
  if (props.paymentPage) {
    const data = {
      subscription_id: subId.value,
      key,
    }
    window.location.href = `${props.paymentPage}?${STATE.stringify(data)}`
  }
}
async function getSubscription(params = {}) {
  const transformedData = {limit: 5 ,...params}
  try {
    const keys = (await executeWithRefresh( userKeysListResource, null, {...transformedData}))
    const orders = (await executeWithRefresh( userOrdersListResource, null, {}))
    pagination.value = keys.data.pagination
    kyesList.value = keys.data.items
    ordersList.value = orders.data.items
  } catch(e) {
    return Promise.reject(e)
  }
}
function handlePaginate(params) {
  getSubscription({ ...params })
  }

onMounted(() => {
  getSubscription()
})

const isAuth = storage.getItem(HQ_VPN_IS_AUTH_STORAGE_NAME)
if (!isAuth) window.location.href = window.loginPage

const __returned__ = { router, route, $t, props, kyesList, ordersList, keysTypes, loginPage, pagination, getDaysForDate, updateKey, getSubscription, handlePaginate, isAuth, ref, onMounted, toRefs, useGlobal, executeWithRefresh, userOrdersListResource, userKeysListResource, STATE, differenceInDays, storage, HQ_VPN_IS_AUTH_STORAGE_NAME, useRouter, useRoute }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})